import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, styled } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import PaperplaneGif from 'src/assets/images/paperplane.gif';

const SignUpSuccess: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation('authentication-wall');
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <PaperPlane src={PaperplaneGif} />
      <Box
        sx={{
          mb: '16px',
        }}
      >
        <Typography variant='font32'>{t('signUp.successTitle')}</Typography>
      </Box>
      <Typography variant='font16'>{t('signUp.successSubtitle')}</Typography>
    </Box>
  );
};

export default SignUpSuccess;

const PaperPlane = styled('img')`
  width: 50%;
  height: 50%;
`;
